// extracted by mini-css-extract-plugin
module.exports = {"NavigationItems":"NavigationItems__NavigationItems___yd_d","Social":"NavigationItems__Social__1aMqG","Ico":"NavigationItems__Ico__2MeYa","SignIn":"NavigationItems__SignIn__2ITQx"};